export const ApiStatus = {
    NONE: 'NONE',
    LOADING: 'LOADING',
    DOWNLOADING: 'DOWNLOADING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR'
  };